"use client";

import { Contact } from "./Contact";

export const PageContact = () => {
  return <Contact />;
};
